import React, {useState, useEffect, useMemo} from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useRates } from "../hooks/useRates";
import "./Calculator.css";
import GlassyButton from "./GlassyButton";

import rub_img from '../assets/icons/rub.svg';
import usdt_img from '../assets/icons/usdt.svg';

import exchange_icon from '../assets/icons/arrow_down.svg';

export default function Calculator() {
    const rates = useRates();
    const [from, setFrom] = useState("USDT");
    const [to, setTo] = useState("RUB");
    const [amount, setAmount] = useState("0");
    const [result, setResult] = useState("");

    // пересчёт результата при изменениях
    useEffect(() => {
        if (!rates || !amount || Number(amount) <= 0) {
            setResult("");
            return;
        }

        let out = 0;
        if (from === "RUB" && to === "USDT") {
            out = Number(amount) / rates.buyRate;
        } else if (from === "USDT" && to === "RUB") {
            out = Number(amount) * rates.sellRate;
        }
        setResult(out.toFixed(2));
    }, [amount, from, to, rates]);




    // swap с анимацией
    const handleSwap = () => {
        setFrom(to);
        setTo(from);

        // свап значений
        setAmount(result);
        setResult(amount);
    };


    const handleClick = () => {
        const username = "obmenvpermi";
        const message = `Здравствуйте! Хочу купить ${(+amount)?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 0})} ${from}`;
        const url = `https://t.me/${username}?text=${encodeURIComponent(message)}`;

        window.location.href = url;

        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        }
    };


    return (
        <div className="calc-card card">

            <div className={'calc-inputs'}>
                <div className="calc-row">
                    <div className="calc-input-wrapper">

                        <div className={'calc-input-top'}>
                            <h5 className={'uppercase normal opacity75'}>
                                Отдаете
                            </h5>

                            <div className={'calc-input-top-right'}>

                                <img src={from === 'RUB' ? rub_img : usdt_img} alt={from}/>

                                <h5 className={'uppercase bold'}>
                                    {from}
                                </h5>
                            </div>

                        </div>


                        <input
                            className="calc-input"
                            type="text"
                            value={
                                amount
                                    ? Number(amount).toLocaleString() // 5 000 или 100 000
                                    : ""
                            }
                            onChange={(e) => {
                                const raw = e.target.value.replace(/\s/g, "").replace(/,/g, "");
                                if (!isNaN(raw)) {
                                    setAmount(raw);
                                }
                            }}
                            placeholder="0"
                        />

                        <div className={'calc-input-bottom'}>

                            {rates && from === "RUB" && (
                                <p className={'opacity75'}>{(rates.sellRate).toFixed(2)} RUB ≈ 1USDT</p>
                            )}

                            {rates && from === "USDT" && (
                                <p className={'opacity75'}>1USDT ≈ {rates.buyRate.toFixed(2)}RUB</p>
                            )}

                            &nbsp;

                        </div>

                    </div>
                </div>

                <div
                    className={'calc-swap'}
                    onClick={handleSwap}
                >
                    <img src={exchange_icon} alt={'arrow'}/>
                </div>


                <div className="calc-row second">
                    <div className="calc-input-wrapper">

                        <div className={'calc-input-top'}>
                            <h5 className={'uppercase normal opacity75'}>
                                Получаете
                            </h5>

                            <div className={'calc-input-top-right'}>

                                <img src={to === 'RUB' ? rub_img : usdt_img} alt={from}/>

                                <h5 className={'uppercase bold'}>
                                    {to}
                                </h5>
                            </div>

                        </div>

                        <input
                            className="calc-input"
                            type="text"
                            value={
                                result
                                    ? Number(result).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                    : ""
                            }
                            readOnly
                            placeholder="0"
                        />


                        {/*<div className={'calc-input-bottom'}>

                            {rates && from === "USDT" && (
                                <p className={'opacity75'}>{(rates.buyRate).toFixed(2)} RUB ≈ 1USDT</p>
                            )}

                            {rates && from === "RUB" && (
                                <p className={'opacity75'}>1USDT ≈ {rates.sellRate.toFixed(2)}RUB</p>
                            )}

                            &nbsp;

                        </div>*/}


                    </div>
                </div>
            </div>


            <div className="calc-info">
                <p className={''}>
                    Зафиксировать курс можно в диалоге с оператором*
                </p>
            </div>

            <GlassyButton className={'full'} onClick={() => handleClick()}>
                Купить {to}
            </GlassyButton>


        </div>
    );
}
